import React, { useMemo, useState } from "react";
import HubBanner from "../../../../components/sections/front/hub/HubBanner";
import HubSidepanel from "../../../../components/sections/front/hub/HubSidepanel";
import Tabs from "../../../../components/elements/Tabs";
import HubEvents from "../../../../components/sections/front/hub/HubEvents";
import HubInterests from "../../../../components/sections/front/hub/HubInterests";
import HubReviews from "../../../../components/sections/front/hub/HubReviews";
import { t } from "i18next";

const Hub = () => {
  // const [selectedTab, setSelectedTab] = useState(0);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [totalEvents, setTotalEvents] = useState(0);

  const tabItems = [
    ...(!["profile"].includes(selectedProfile?.description)
      ? [
          {
            label: t("Hosting"),
            icon: "fa-regular fa-users text-xl",
            content: (
              <HubEvents
                selectedProfile={selectedProfile}
                setTotalEvents={setTotalEvents}
              />
            ),
          },
        ]
      : []),
    ...(!["organization"].includes(selectedProfile?.description)
      ? [
          {
            label: t("Interests"),
            icon: "fa-regular fa-heart text-xl",
            content: <HubInterests selectedProfile={selectedProfile} />,
          },
        ]
      : []),
    ...(!["profile"].includes(selectedProfile?.description)
      ? [
          {
            label: t("Reviews"),
            icon: "fa-regular fa-medal text-xl",
            content: <HubReviews selectedProfile={selectedProfile} />,
          },
        ]
      : []),
  ];

  return (
    <section className="bg-gray-100">
      <HubBanner />
      <div className="max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl w-full mx-auto px-6">
        <div className="grid lg:grid-cols-4 gap-0 lg:gap-8">
          <div className="relative">
            <HubSidepanel
              selectedProfile={selectedProfile}
              totalEvents={totalEvents}
              setSelectedProfile={(val) => {
                // setSelectedTab(0);
                setSelectedProfile(val);
              }}
            />
          </div>
          <div className="relative lg:col-span-3 py-4 pb-12 lg:py-12">
            <Tabs
              // selectedIndex={selectedTab}
              // setSelectedIndex={setSelectedTab}
              items={tabItems}
              contentClass={"!px-0"}
              tabsClass="!bg-white !rounded-xl !py-2 !px-2 !shadow"
              tabClass={""}
              activeTabClass={"!bg-primary !text-white !text-white !shadow"}
              tabButtonClass={
                "flex-shrink flex-grow !py-2 !px-4 !border-0 !justify-center !text-base text-black !rounded-xl"
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hub;
